import { Injectable, OnDestroy } from '@angular/core';
import {
  Observable,
  BehaviorSubject,
  Subscription,
  merge,
  of,
  fromEvent,
  map,
  interval,
} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class checkConnectivityService implements OnDestroy {
  private isConnectedSubject: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(true);
  isConnected$: Observable<boolean> = this.isConnectedSubject.asObservable();

  private speedSubject: BehaviorSubject<string> = new BehaviorSubject<string>(
    ''
  );
  speed$: Observable<string> = this.speedSubject.asObservable();

  private intervalSubscription: Subscription = new Subscription();
  networkStatus: boolean = false;
  networkStatus$: Subscription = Subscription.EMPTY;

  constructor() {
    this.intervalSubscription = interval(5000).subscribe(() => {
      this.verifyConnection();
      this.verifyConnectionSpeed();
    });
  }

  ngOnDestroy() {
    this.intervalSubscription.unsubscribe();
    this.networkStatus$.unsubscribe();
  }

  private verifyConnection() {
    this.networkStatus = navigator.onLine;
    this.networkStatus$ = merge(
      of(null),
      fromEvent(window, 'online'),
      fromEvent(window, 'offline')
    )
      .pipe(map(() => navigator.onLine))
      .subscribe((status) => {
        this.networkStatus = status;
        this.updateConnectionStatus(status);
      });
  }

  private verifyConnectionSpeed() {
    const conn = (navigator as any).connection;
    if (conn) {
      if (conn.saveData) {
        // do something
      }
      const connectionlist = ['slow-2g', '2g', '3g', '4g'];
      const effectiveType = conn.effectiveType;
      this.updateSpeedConnection(effectiveType);
    }
  }

  private updateConnectionStatus(isConnected: boolean) {
    this.isConnectedSubject.next(isConnected);
  }

  private updateSpeedConnection(speed: string) {
    this.speedSubject.next(speed);
  }
}
